var map = {
	"./Menu_Icons-10.svg": "2b6e",
	"./add-simple.svg": "ecb3",
	"./archive.svg": "8238",
	"./arrow-icons/icons_bi-dir.svg": "6002",
	"./arrow-icons/icons_dotted.svg": "d888",
	"./arrow-icons/icons_from.svg": "ace9",
	"./arrow-icons/icons_non-dir.svg": "b320",
	"./arrow-icons/icons_solid.svg": "1785",
	"./arrow-icons/icons_to.svg": "40a3",
	"./backBtn.svg": "bd53",
	"./bookmark-fill.svg": "7e3b",
	"./bookmark.svg": "7253",
	"./cancel.svg": "b463",
	"./cards/ico-designation.svg": "11ef",
	"./cards/ico-personal-email-address.svg": "8b4b",
	"./caret-down.svg": "3f24",
	"./caret-left.svg": "eee76",
	"./case-types/customers-dd-l1.svg": "4c6e",
	"./case-types/customers-dd-l2.svg": "1e56",
	"./case-types/customers-dd-l3.svg": "2927",
	"./case-types/investigation-dd-l1.svg": "b129",
	"./case-types/investigation.svg": "c5a4",
	"./case-types/investment-dd-l1.svg": "ac31",
	"./case-types/investment-dd-l2.svg": "a109",
	"./case-types/investment-dd-l3.svg": "cd42",
	"./case-types/online-reputation-l1.svg": "94261",
	"./case-types/social-media-+-database.svg": "7c30",
	"./case-types/social-media-screening.svg": "f8eb",
	"./check-mark.svg": "2677",
	"./check.svg": "7bae",
	"./check_solid.svg": "b3a4",
	"./checked.svg": "0aae",
	"./compare-btn.svg": "99b8",
	"./credit-card-bold.svg": "cfaa",
	"./cross.svg": "2ad7",
	"./def-image.svg": "ebf7",
	"./delete-icon.svg": "7b39",
	"./delete.svg": "0d45",
	"./documents.svg": "70cd",
	"./dropdown.svg": "6d05",
	"./edit.svg": "daf0",
	"./errors/ico-no-profile.svg": "386b",
	"./filter-component/companies.svg": "9570",
	"./filter-component/internet.svg": "6d17",
	"./filter-component/locations.svg": "64e1",
	"./filter-component/matching-identifiers.svg": "894b",
	"./filter-component/people.svg": "52c5",
	"./filter-component/risks.svg": "e547",
	"./filter-component/topic-classification.svg": "4b11",
	"./flag.svg": "c26e",
	"./flag1.svg": "cbaf",
	"./flags/ad.svg": "5baa",
	"./flags/ae.svg": "a951",
	"./flags/af.svg": "39a3",
	"./flags/ag.svg": "7263",
	"./flags/ai.svg": "6acc",
	"./flags/al.svg": "f938",
	"./flags/am.svg": "6737",
	"./flags/an.svg": "403d",
	"./flags/ao.svg": "580b",
	"./flags/aq.svg": "1cde",
	"./flags/ar.svg": "2de3",
	"./flags/as.svg": "7b99",
	"./flags/at.svg": "137f",
	"./flags/au.svg": "997b",
	"./flags/aw.svg": "7fdb",
	"./flags/ax.svg": "2d412",
	"./flags/az.svg": "96f1",
	"./flags/ba.svg": "360e",
	"./flags/bb.svg": "9b3d",
	"./flags/bd.svg": "5c52",
	"./flags/be.svg": "160f",
	"./flags/bf.svg": "26b9",
	"./flags/bg.svg": "27da",
	"./flags/bh.svg": "0a81",
	"./flags/bi.svg": "6a40",
	"./flags/bj.svg": "bbe6",
	"./flags/bl.svg": "b354",
	"./flags/bm.svg": "f8c3",
	"./flags/bn.svg": "8adf",
	"./flags/bo.svg": "a132",
	"./flags/bq.svg": "ad77",
	"./flags/br.svg": "23c9",
	"./flags/bs.svg": "f9c3",
	"./flags/bt.svg": "0aa9",
	"./flags/bv.svg": "3f8c9",
	"./flags/bw.svg": "6143",
	"./flags/by.svg": "a4a7",
	"./flags/bz.svg": "b919",
	"./flags/ca.svg": "a0c0",
	"./flags/cc.svg": "5ad4",
	"./flags/cd.svg": "a57b",
	"./flags/cf.svg": "88b3",
	"./flags/cg.svg": "7077",
	"./flags/ch.svg": "7306",
	"./flags/ci.svg": "39b6",
	"./flags/ck.svg": "f6be",
	"./flags/cl.svg": "3df4",
	"./flags/cm.svg": "3c63",
	"./flags/cn.svg": "f3d0",
	"./flags/co.svg": "622c",
	"./flags/cr.svg": "d12c",
	"./flags/cu.svg": "bedb",
	"./flags/cv.svg": "e54f",
	"./flags/cw.svg": "4e2f",
	"./flags/cx.svg": "7e74",
	"./flags/cy.svg": "a5d94",
	"./flags/cz.svg": "f428",
	"./flags/de.svg": "1a15",
	"./flags/dj.svg": "3aed",
	"./flags/dk.svg": "6980",
	"./flags/dm.svg": "5fec",
	"./flags/do.svg": "a932",
	"./flags/dz.svg": "b55c",
	"./flags/ec.svg": "954e",
	"./flags/ee.svg": "c524",
	"./flags/eg.svg": "78ca",
	"./flags/eh.svg": "24a3",
	"./flags/er.svg": "5a9e",
	"./flags/es-ct.svg": "8536",
	"./flags/es.svg": "f35d",
	"./flags/et.svg": "77d5",
	"./flags/eu.svg": "5c16",
	"./flags/fi.svg": "d0a1",
	"./flags/fj.svg": "c9eb",
	"./flags/fk.svg": "46cb",
	"./flags/fm.svg": "59ac",
	"./flags/fo.svg": "ef48",
	"./flags/fr.svg": "26da",
	"./flags/ga.svg": "781e",
	"./flags/gb-eng.svg": "9f08",
	"./flags/gb-nir.svg": "2015",
	"./flags/gb-sct.svg": "146d",
	"./flags/gb-wls.svg": "1f08",
	"./flags/gb.svg": "0fd5",
	"./flags/gd.svg": "4a92",
	"./flags/ge.svg": "dc5e",
	"./flags/gf.svg": "f3d1",
	"./flags/gg.svg": "ff1e",
	"./flags/gh.svg": "053e",
	"./flags/gi.svg": "3086",
	"./flags/gl.svg": "0f88",
	"./flags/gm.svg": "2d01",
	"./flags/gn.svg": "9c8c",
	"./flags/gp.svg": "21f0",
	"./flags/gq.svg": "aeb5a",
	"./flags/gr.svg": "d605",
	"./flags/gs.svg": "454b",
	"./flags/gt.svg": "c9be",
	"./flags/gu.svg": "94a0",
	"./flags/gw.svg": "07ad",
	"./flags/gy.svg": "2229",
	"./flags/hk.svg": "8b83",
	"./flags/hm.svg": "0d84",
	"./flags/hn.svg": "cd3e",
	"./flags/hr.svg": "7d5e",
	"./flags/ht.svg": "2e73",
	"./flags/hu.svg": "c08b",
	"./flags/id.svg": "4b71",
	"./flags/ie.svg": "a5fe",
	"./flags/il.svg": "fccf",
	"./flags/im.svg": "d0cb",
	"./flags/in.svg": "36ca",
	"./flags/io.svg": "f29b",
	"./flags/iq.svg": "9a4f",
	"./flags/ir.svg": "c6a4",
	"./flags/is.svg": "5beaf",
	"./flags/it.svg": "8fb1",
	"./flags/je.svg": "7f02",
	"./flags/jm.svg": "397c",
	"./flags/jo.svg": "fab4",
	"./flags/jp.svg": "27cb",
	"./flags/ke.svg": "49c9",
	"./flags/kg.svg": "a3d2",
	"./flags/kh.svg": "ae8b",
	"./flags/ki.svg": "c15c",
	"./flags/km.svg": "d29b",
	"./flags/kn.svg": "7e74a",
	"./flags/kp.svg": "caf8",
	"./flags/kr.svg": "814a",
	"./flags/kw.svg": "be3f",
	"./flags/ky.svg": "7d8e8",
	"./flags/kz.svg": "9803",
	"./flags/la.svg": "383f",
	"./flags/lb.svg": "2029",
	"./flags/lc.svg": "8bfd",
	"./flags/li.svg": "26e7",
	"./flags/lk.svg": "b408",
	"./flags/lr.svg": "8a0c",
	"./flags/ls.svg": "957f",
	"./flags/lt.svg": "281e",
	"./flags/lu.svg": "33dc",
	"./flags/lv.svg": "d1c4",
	"./flags/ly.svg": "20db",
	"./flags/ma.svg": "5a8b",
	"./flags/mc.svg": "92ad",
	"./flags/md.svg": "6229",
	"./flags/me.svg": "2141",
	"./flags/mf.svg": "e257",
	"./flags/mg.svg": "9871",
	"./flags/mh.svg": "27f3",
	"./flags/mk.svg": "6707",
	"./flags/ml.svg": "d04b",
	"./flags/mm.svg": "6559",
	"./flags/mn.svg": "19da",
	"./flags/mo.svg": "87505",
	"./flags/mp.svg": "ba63",
	"./flags/mq.svg": "437b",
	"./flags/mr.svg": "3b10",
	"./flags/ms.svg": "62c3",
	"./flags/mt.svg": "7a02",
	"./flags/mu.svg": "af12",
	"./flags/mv.svg": "263c",
	"./flags/mw.svg": "4e54",
	"./flags/mx.svg": "e7a6",
	"./flags/my.svg": "35d2",
	"./flags/mz.svg": "089a",
	"./flags/na.svg": "1866",
	"./flags/nc.svg": "9fff",
	"./flags/ne.svg": "a64d",
	"./flags/nf.svg": "b758",
	"./flags/ng.svg": "4326",
	"./flags/ni.svg": "df62",
	"./flags/nl.svg": "0e72",
	"./flags/no.svg": "24a30",
	"./flags/np.svg": "5b99",
	"./flags/nr.svg": "436b",
	"./flags/nu.svg": "f67f",
	"./flags/nz.svg": "a0e9",
	"./flags/om.svg": "3fd3",
	"./flags/pa.svg": "680d",
	"./flags/pe.svg": "0473",
	"./flags/pf.svg": "9cb63",
	"./flags/pg.svg": "7147",
	"./flags/ph.svg": "1aa5",
	"./flags/pk.svg": "fae0",
	"./flags/pl.svg": "b7d9",
	"./flags/pm.svg": "10b2",
	"./flags/pn.svg": "3baa",
	"./flags/pr.svg": "b69e",
	"./flags/ps.svg": "b6f5",
	"./flags/pt.svg": "1605",
	"./flags/pw.svg": "869d",
	"./flags/py.svg": "8046",
	"./flags/qa.svg": "29f1",
	"./flags/re.svg": "9e4f",
	"./flags/ro.svg": "595a",
	"./flags/rs.svg": "33dd",
	"./flags/ru.svg": "4c2a",
	"./flags/rw.svg": "3abc",
	"./flags/sa.svg": "c3d9",
	"./flags/sb.svg": "0a18",
	"./flags/sc.svg": "5d3c",
	"./flags/sd.svg": "4d9c",
	"./flags/se.svg": "bdd9",
	"./flags/sg.svg": "2b58",
	"./flags/sh.svg": "863e",
	"./flags/si.svg": "e74e",
	"./flags/sj.svg": "a33a",
	"./flags/sk.svg": "d533",
	"./flags/sl.svg": "202c",
	"./flags/sm.svg": "bfe4",
	"./flags/sn.svg": "f8c2",
	"./flags/so.svg": "ff71",
	"./flags/sr.svg": "281ea",
	"./flags/ss.svg": "6d22",
	"./flags/st.svg": "ea7a",
	"./flags/sv.svg": "a34b",
	"./flags/sx.svg": "987d",
	"./flags/sy.svg": "b179",
	"./flags/sz.svg": "3867",
	"./flags/tc.svg": "fcf7",
	"./flags/td.svg": "4b2d",
	"./flags/tf.svg": "df0c",
	"./flags/tg.svg": "1396d",
	"./flags/th.svg": "e1a3",
	"./flags/tj.svg": "f3f0",
	"./flags/tk.svg": "c8aa",
	"./flags/tl.svg": "c2b5",
	"./flags/tm.svg": "f6ee",
	"./flags/tn.svg": "aca0",
	"./flags/to.svg": "2b26",
	"./flags/tr.svg": "5aef",
	"./flags/tt.svg": "c475",
	"./flags/tv.svg": "2f27",
	"./flags/tw.svg": "2c3d",
	"./flags/tz.svg": "6bc1",
	"./flags/ua.svg": "633e",
	"./flags/ug.svg": "99b9",
	"./flags/um.svg": "a2e4",
	"./flags/un.svg": "3c5a",
	"./flags/us.svg": "be1b",
	"./flags/uy.svg": "6f5e",
	"./flags/uz.svg": "8809",
	"./flags/va.svg": "1f8c",
	"./flags/vc.svg": "5107",
	"./flags/ve.svg": "6664",
	"./flags/vg.svg": "520d",
	"./flags/vi.svg": "75e5",
	"./flags/vn.svg": "ace0",
	"./flags/vu.svg": "0693",
	"./flags/wf.svg": "eb17",
	"./flags/ws.svg": "7417",
	"./flags/xk.svg": "95f5",
	"./flags/ye.svg": "d2bd",
	"./flags/yt.svg": "3cbb",
	"./flags/za.svg": "16f0",
	"./flags/zm.svg": "3784",
	"./flags/zw.svg": "aae9",
	"./flickr.svg": "b735",
	"./folder.svg": "383d",
	"./global-filter.svg": "e97c",
	"./goodreads.svg": "7766",
	"./google-maps.svg": "dc61",
	"./graph-icon.svg": "601c0",
	"./graph.png": "17ee",
	"./graph/address-green.png": "3b7d",
	"./graph/address.png": "389d",
	"./graph/address.svg": "7ac8",
	"./graph/cancel.png": "c55b",
	"./graph/caret-down.png": "0491",
	"./graph/circle.png": "fd27",
	"./graph/close.png": "cdb1",
	"./graph/color-picker.png": "8c11",
	"./graph/color-wheel (1).png": "cdd3",
	"./graph/color-wheel.png": "4784",
	"./graph/company-green.png": "a60c",
	"./graph/company.png": "6203",
	"./graph/company_icon.svg": "9b97",
	"./graph/country-green.png": "ccd7",
	"./graph/country.png": "4c42",
	"./graph/date-green.png": "3a8f",
	"./graph/date.png": "cd94",
	"./graph/default.png": "aeb5",
	"./graph/domain.svg": "f50e",
	"./graph/editing.png": "c24f",
	"./graph/education.svg": "ce9e",
	"./graph/email.png": "b334",
	"./graph/employees.svg": "5f9d",
	"./graph/eye.png": "d7be",
	"./graph/g-add.svg": "cff6",
	"./graph/g-edit.svg": "a121",
	"./graph/g-remove.svg": "9915",
	"./graph/g-spline.svg": "643c",
	"./graph/g-trash.svg": "3247",
	"./graph/hierarchy.png": "bc9b",
	"./graph/ico-search-query.svg": "c49c",
	"./graph/internet.png": "164f",
	"./graph/job.svg": "ce1b",
	"./graph/location.png": "d10f",
	"./graph/minus-sign.png": "dda0",
	"./graph/network.png": "42ad",
	"./graph/person-green.png": "2b06",
	"./graph/person.png": "a4ea",
	"./graph/phone-call.png": "7921",
	"./graph/plus.png": "2bd2e",
	"./graph/plus2.png": "f5ac",
	"./graph/risk.png": "36a6",
	"./graph/settings.png": "fd83",
	"./graph/split.png": "c2b8",
	"./graph/subject.svg": "99c9",
	"./graph/unknown.png": "5bde",
	"./graph/user.bk1.png": "be0a",
	"./graph/user.png": "17e9",
	"./graph/user_1.png": "daa2",
	"./graph/web-link.png": "13d9",
	"./ico-active-media.svg": "fd90",
	"./ico-add-blue.svg": "4ad5",
	"./ico-add-new.svg": "5676",
	"./ico-add.svg": "af5a",
	"./ico-alert.svg": "4614",
	"./ico-arc.svg": "a261",
	"./ico-box-closed.svg": "9a47",
	"./ico-caret-blue.svg": "aa17",
	"./ico-caret-down.svg": "1520",
	"./ico-caret-left-brand-color.svg": "206b",
	"./ico-caret-left-white.svg": "f191",
	"./ico-caret-left.svg": "4fc5",
	"./ico-caret-right-blue.svg": "b90a",
	"./ico-caret-right-white.svg": "b924",
	"./ico-case.svg": "f4d8",
	"./ico-cases.svg": "2c14",
	"./ico-check-circle.svg": "7391",
	"./ico-checkmark-cicle.svg": "be9e",
	"./ico-close-grey.svg": "4199",
	"./ico-close-white.svg": "f4fe",
	"./ico-close.svg": "5bea",
	"./ico-cloud-data.svg": "3fb0",
	"./ico-collapse-brand-color.svg": "66da",
	"./ico-collapse-cards.svg": "6a8f",
	"./ico-completed-on.svg": "2675",
	"./ico-copy.svg": "1e13",
	"./ico-created-on.svg": "9db6",
	"./ico-dash.svg": "9845",
	"./ico-default-avatar.svg": "d17a",
	"./ico-default-img.svg": "9903",
	"./ico-delete.svg": "98bb",
	"./ico-double-arrows-right.svg": "a622",
	"./ico-down-arrow.svg": "0eeb",
	"./ico-download.svg": "849e",
	"./ico-edit-brand-color.svg": "66d1",
	"./ico-edit-color.svg": "2913",
	"./ico-edit.svg": "0f23",
	"./ico-education.svg": "a6a6",
	"./ico-email-rounded.svg": "e12e",
	"./ico-employment.svg": "1945",
	"./ico-expand-brand-color.svg": "84ea",
	"./ico-expand-cards.svg": "4822",
	"./ico-expand-white.svg": "338b",
	"./ico-expand.svg": "ee7d",
	"./ico-facebook.svg": "e454",
	"./ico-gear.svg": "4540",
	"./ico-ham.svg": "38e7",
	"./ico-hide.svg": "07db",
	"./ico-info.svg": "1bfb",
	"./ico-key-facts.svg": "4968",
	"./ico-line.svg": "ea97",
	"./ico-link.svg": "de66",
	"./ico-location.svg": "64bc",
	"./ico-mail.svg": "ec50",
	"./ico-messages.svg": "bdc3",
	"./ico-monitor.svg": "87e3",
	"./ico-more.svg": "47d8",
	"./ico-notifications.svg": "3999",
	"./ico-office.svg": "b4ad",
	"./ico-passive-media.svg": "c5d9",
	"./ico-plus.svg": "a9f7",
	"./ico-preview-brand-color.svg": "047f",
	"./ico-preview.svg": "90b9",
	"./ico-question.svg": "dd5b",
	"./ico-redo.svg": "e85fb",
	"./ico-refresh-grey.svg": "51c1",
	"./ico-refresh.svg": "44f3",
	"./ico-reports.svg": "ac76",
	"./ico-research.svg": "46f8",
	"./ico-reset-sort.png": "ea0c",
	"./ico-restore.svg": "5c41",
	"./ico-save-brand-color.svg": "5e30",
	"./ico-save.svg": "60d9",
	"./ico-search-focus.svg": "96380",
	"./ico-search.svg": "14cd",
	"./ico-show.svg": "3b77",
	"./ico-simulation.svg": "a3b5",
	"./ico-social.svg": "c8b4",
	"./ico-sort.svg": "a4df",
	"./ico-tag.svg": "a6a8",
	"./ico-telephone-brand-color.svg": "28c8",
	"./ico-thumbnail.svg": "cc90",
	"./ico-time.svg": "cf1f",
	"./ico-trash-red.svg": "4f46",
	"./ico-trash-white.svg": "2d7c",
	"./ico-trash.svg": "e01b",
	"./ico-undo.svg": "8f0c",
	"./ico-up-arrow.svg": "c02f",
	"./ico-upload-cloud.svg": "b9e0",
	"./ico-url.svg": "6ce1",
	"./ico-user-brand-color.svg": "ab7b",
	"./ico-user.svg": "392f",
	"./ico-warn.svg": "9be8",
	"./ico-work.svg": "e37dd",
	"./ico-workflow.svg": "5bfb",
	"./ico-zoom-in.svg": "5a86",
	"./ico-zoom-out.svg": "3406",
	"./icon-editor.svg": "e535",
	"./icon-reports.svg": "b29a",
	"./icon-template.svg": "93e8",
	"./info.svg": "76ed",
	"./intelligence.svg": "7299",
	"./layer-group.svg": "b9d4",
	"./letter-x.svg": "b599",
	"./list.svg": "99ad",
	"./mapmyrun.svg": "54e5",
	"./menu.svg": "d17f",
	"./minus.svg": "3e24",
	"./question_solid.svg": "1ecc",
	"./search-engines/analyser-complete.svg": "1695",
	"./search-engines/analyser-done.svg": "cde5",
	"./search-engines/analyser.svg": "8bd4f",
	"./search-engines/bing.svg": "c51b",
	"./search-engines/google.svg": "b452",
	"./search-engines/yahoo.svg": "fdeb",
	"./search-engines/yandex.svg": "72ef",
	"./social-medias/add.svg": "76b5",
	"./social-medias/all.svg": "ac0b",
	"./social-medias/angellist.svg": "b059",
	"./social-medias/f6s.svg": "11fa",
	"./social-medias/facebook.svg": "8708",
	"./social-medias/flickr.svg": "0ea4",
	"./social-medias/github.svg": "c345a",
	"./social-medias/gitlab.svg": "6e38",
	"./social-medias/google.svg": "e438",
	"./social-medias/googleid.svg": "fd0c",
	"./social-medias/instagram.svg": "ca15",
	"./social-medias/linkedin.svg": "ed1e",
	"./social-medias/medium.svg": "f359",
	"./social-medias/other.svg": "ece9",
	"./social-medias/pinterest.svg": "3a0d",
	"./social-medias/skype.svg": "eec6",
	"./social-medias/stackoverflow.svg": "acec",
	"./social-medias/twitter.svg": "9426",
	"./social-medias/website.svg": "b05ec",
	"./social-medias/youtube.svg": "92fc",
	"./swiper-arrow.svg": "07fb",
	"./tiktok.svg": "68b6",
	"./timer.svg": "291e",
	"./topic-classification.svg": "73ac9",
	"./triangle_exclamation.svg": "979e",
	"./types/Graph_icons_Adverse Tag.svg": "64cd",
	"./types/Graph_icons_Subject.svg": "e0ab",
	"./types/ico-activity.svg": "4adc",
	"./types/ico-bank.svg": "4203",
	"./types/ico-book.svg": "3815",
	"./types/ico-company.svg": "ed5b",
	"./types/ico-crime.svg": "e21c",
	"./types/ico-cyber.svg": "839a",
	"./types/ico-education.svg": "6711",
	"./types/ico-email.svg": "dba5",
	"./types/ico-facebook.svg": "4678",
	"./types/ico-google.svg": "6236",
	"./types/ico-hack.svg": "5f5e",
	"./types/ico-home.svg": "0f61",
	"./types/ico-instagram.svg": "4cbd",
	"./types/ico-linkedin.svg": "370e",
	"./types/ico-main.svg": "d02b",
	"./types/ico-media.svg": "8b75",
	"./types/ico-money.svg": "dfda",
	"./types/ico-phone.svg": "8202",
	"./types/ico-relation.svg": "79f9",
	"./types/ico-security.svg": "033c",
	"./types/ico-social_media.svg": "62f7",
	"./types/ico-subject.svg": "a93a",
	"./types/ico-web.svg": "3967",
	"./types/ico-work.svg": "545b",
	"./user.svg": "6aed",
	"./verified.png": "c53b",
	"./view.svg": "00ed",
	"./warn.svg": "d7a4",
	"./x-mark.svg": "328f",
	"./xmark.svg": "dc66"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";